const e = (t) => ({
  ...t,
  withCredentials: !0,
  timeout: 6e4,
  maxBodyLength: 104857600,
  maxContentLength: 104857600,
  throwOnError: !0,
  credentials: "include"
});
export {
  e as createClientConfig
};
